/** Common routines for accessing configurations, not recommended for keeping configurations, unless they never change */

export function hasIDVerification() {
  return process.env.REACT_APP_PERSONA_ENABLED === "true";
}
